import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import Navbar from "./pages/Navbar";
import BlankPage from "./pages/BlankPage";


export default function App() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/tos_policy" element={<BlankPage file='ToS' />} />
        <Route path="/eula" element={<BlankPage file='eula' />} />
        <Route path="/privacy" element={<BlankPage file='privacy' />} />
        <Route path="/refund" element={<BlankPage file='refund' />} />
      </Routes>
    </>
  );
}

